<template>
  <div class="marker-viewer f944f5202">
    <OperatHeader
      class="shared"
      :leftActionStyle="{ left: !layerListShow ? 'var(--no-left)' : undefined }"
    >
      <div slot="left-action">
        <SearchInput></SearchInput>
      </div>
      <div slot="right-action">
        <MapTools
          @drawEndMsg="onDrawEnd"
          @drawBegin="onDrawBegin"
          @inputPoint="onInputPoint"
          :showDrawTool= "!isTemplate && !shared"
          :showAnalyseTool="{
            splitScreenContrast:!isTemplate && !shared,
            spaceSearch:!isTemplate && !shared
          }"
        ></MapTools>
      </div>
    </OperatHeader>
    <LeftDrawer v-if="layerListShow">
      <div slot="header">
        <span class="title">图层管理</span>
        <span class="icons" v-show="!isTemplate && !shared">
          <Icon
            type="big"
            name="icon-folder-a"
            content="新建文件夹"
            :disabled="permissionLevel <= PermissionLevel.LOOKER"
            @click="createFolder"
          ></Icon>
          <Icon
            type="big"
            name="icon-layers"
            content="新建图层"
            :disabled="permissionLevel <= PermissionLevel.LOOKER"
            @click="createLayer"
          ></Icon>
          <Icon
            v-if="isSppuc && sppucAccount"
            type="big"
            name="icon-shujuronghe"
            content="新建融合通信图层"
            :disabled="permissionLevel <= PermissionLevel.LOOKER"
            @click="createSppucLayer"
          ></Icon>
        </span>
      </div>
      <div
        class="ah"
        slot="body"
        v-if="!layerTree || layerTree.children.length <= 0"
      >
        <Empty></Empty>
      </div>
      <div class="ah" slot="body" v-if="layerTree && layerTree.children.length">
        <div class="ah body-tree">
          <span
            class="statistics"
            v-if="layerList && layerList.length"
            v-show="!shared"
            >{{ layerList.length }}个图层{{ markerCount }}条记录</span
          >
          <el-tree
            class="layer-list ah"
            ref="layerList"
            :data="layerTree.children"
            :props="layerProps"
            @node-click="clickLayer"
            node-key="clientId"
            highlight-current
            :draggable="!isTemplate && !shared"
            :expand-on-click-node="false"
            :default-expand-all="true"
            @node-drag-end="handleDragEnd"
            :allow-drop="allowDrop"
            v-show="!!layerTree"
            :style="{ 'margin-top': shared ? '0px' : undefined }"
          >
            <span class="layer-item" slot-scope="{ data }">
              <Icon
                type="big"
                :name="getLayerIcon(data)"
                class="layerIconStyle"
              ></Icon>
              <el-tooltip
                :content="data.name"
                placement="top"
                effect="light"
                :open-delay="1000"
                :enterable="false"
              >
                <!-- <span class="title">{{layerName[data.id]}}<span class="count">({{data.markCount}})</span></span> -->
                <span class="title"
                  >{{ data.name
                  }}<span class="count">({{ data.markCount }})</span></span
                >
              </el-tooltip>
              <!--  -->
              <div class="action-icon" v-show="data.type !== 'FOLDER'">
                <el-dropdown
                  trigger="click"
                  placement="bottom-start"
                  :hide-on-click="true"
                >
                  <span class="el-dropdown-link">
                    <span class="more" slot="reference">
                      <Icon
                        type="big"
                        class="more-icon"
                        style="visibility: collapse; width: 0px"
                        name="el-icon-more"
                      ></Icon>
                    </span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <div class="popover-content">
                      <el-dropdown-item @click.native="showMarkerList(data)"
                        >标注列表</el-dropdown-item
                      >
                      <el-dropdown-item
                        @click.native="showLayerAttribute(data.id)"
                        v-if="data.dataSourceType !== 'API'&&!shared && data.module !== 'sppuc'"
                        >属性管理</el-dropdown-item
                      >
                      <el-dropdown-item
                        v-show="!isTemplate && !shared"
                        :disabled="permissionLevel <= PermissionLevel.LOOKER"
                        @click.native="onRemoveLayer(data.id)"
                        >删除图层</el-dropdown-item
                      >
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
                <Icon
                  type="big"
                  :name="
                    layerVisible[data.clientId] === false
                      ? 'icon-eye-close'
                      : 'icon-browse'
                  "
                  @click.native.stop="showMarker(data)"
                ></Icon>
              </div>
              <div class="action-icon" v-show="data.type === 'FOLDER'">
                <Icon
                  type="big"
                  v-show="!isTemplate"
                  class="icon-ashbin"
                  name="icon-ashbin"
                  style="visibility: collapse; width: 0px"
                  content="删除"
                  :disabled="permissionLevel <= PermissionLevel.LOOKER"
                  @click="onRemoveFolder(data)"
                  v-if="!shared"
                ></Icon>
                <Icon
                  type="big"
                  :name="
                    layerVisible[data.clientId] === false
                      ? 'icon-eye-close'
                      : 'icon-browse'
                  "
                  @click.native.stop="showMarker(data)"
                ></Icon>
              </div>
            </span>
          </el-tree>
        </div>
        <Empty v-show="!layerTree"></Empty>
      </div>
    </LeftDrawer>
    <RightDrawer ref="rightDrawer" :stopPropagation="true" :hiddenDrawer="permissionLevel <= PermissionLevel.LOOKER && !isShowSpaceSearchDraw">
      <!--    图层管理设置-->
      <div class="marker-right" v-show="!isShowSpaceSearchDraw">
        <div slot="header" class="header">
          <span class="title">基础设置</span>
          <!-- <Icon type="big" v-show="layerChanged" name="icon-save" content="保存修改" @click.native="updateLayerStyle"></Icon> -->
          <el-button
            v-show="layerChanged"
            type="primary"
            :loading="loading"
            @click="updateLayerStyle"
            class="save-btn"
            >保存</el-button
          >
        </div>
        <div class="right-body" slot="body">
          <BaseLayerSet
            ref="baseLayerSet"
            v-show="selectedLayer"
            @bindTable="onBindTable"
            @layerStyleChanged="onLayerStyleChange"
            @refresh="updateLayerList"
          ></BaseLayerSet>
          <BaseSetPoint
            ref="baseSetPoint"
            v-show="selectedLayer && selectedLayer.type === 'POINT'"
            @layerStyleChanged="onLayerStyleChange"
            @showIconSelector="onShowIconSelector"
          ></BaseSetPoint>
          <BaseSetLine
            ref="baseSetLine"
            v-show="selectedLayer && selectedLayer.type === 'LINE'"
            @layerStyleChanged="onLayerStyleChange"
          ></BaseSetLine>
          <BaseSetPolygon
            ref="baseSetPolygon"
            v-show="selectedLayer && selectedLayer.type === 'PLANE'"
            @layerStyleChanged="onLayerStyleChange"
          ></BaseSetPolygon>
        </div>
      </div>
      <!--    空间查询统计-->
      <div v-show="isShowSpaceSearchDraw" class="spaceSearch">
        <div slot="header" class="header">
          <span
            class="title"
            :class="activeIndex === 1 ? 'active' : ''"
            @click="activeIndex = 1"
            >查询结果</span
          >
          <span
            class="title"
            :class="activeIndex === 2 ? 'active' : ''"
            @click="activeIndex = 2"
            >结果统计</span
          >
        </div>
        <div slot="body" class="body">
          <SpaceSearchDraw
            :activeIndex.sync="activeIndex"
            @detailMarker="showMarkerDetails"
          ></SpaceSearchDraw>
        </div>
      </div>
    </RightDrawer>
    <!--  标注列表-->
    <MarkerDataTable
      ref="markerDataTable"
      :layerData="selectedLayer"
      @updateMarkerTable="updateMarkerTable"
      @editMarker="showMarkerAttribute"
      @refresh="updateLayerList"
      @detailMarker="showMarkerDetails"
      @detailApiMarker="showApiMarkerDetails"
      @showImportMarker="onShowImportMarker"
      @detailSppucMarker="onClickSppucMarker"
    ></MarkerDataTable>
    <!--  新建图层-->
    <AddLayer
      ref="addLayer"
      @refresh="updateLayerList"
      @createBindTableLayer="onCreateBindTableLayer"
      @showAttribute="showLayerAttribute"
    ></AddLayer>
    <!--  属性管理-->
    <LayerAttribute
      ref="layerAttribute"
      @refresh="updateLayerList"
    ></LayerAttribute>
    <!--  数据确认-->
    <TableDataSelect
      ref="tableDataSelect"
      @refresh="updateLayerList"
      @closeAddLayer="closeAddLayer"
    ></TableDataSelect>
    <ApiDataSelect
      ref="apiDataSelect"
      @refresh="updateLayerList"
      @closeAddLayer="closeAddLayer"
    ></ApiDataSelect>
    <!--  标注属性新增编辑-->
    <MarkerAttribute
      ref="markerAttribute"
      @showBindMarker="showBindMarker"
      @reloadBindMarker="reloadBindMarker"
      @closeBindMarker="closeBindMarker"
      @selectMapMarker="onSelectMapMarker"
      @closeMarkerAttribute = "onCloseMarkerAttribute"
      @refresh="updateLayerList"
      @createdMarkerMsg="onCreatedMarker"
      @previewPicMsg="onPreviewPic"
    ></MarkerAttribute>
    <!--  数据绑定-->
    <TableMarkerBind
      ref="tableMarkerBind"
      @selectBindMarker="onSelectBindMarker"
    ></TableMarkerBind>
    <!--  新建文件夹-->
    <AddFolder ref="addFolder" @refresh="updateLayerList"></AddFolder>
    <!--图标选择-->
    <IconSelector
      ref="iconSelector"
      @selectedIcon="onSetMarkerIcon"
    ></IconSelector>
    <AddPointByGis ref="addPointByGis" @drawEndMsg="onDrawEnd"></AddPointByGis>
    <!-- 分屏对比 -->
    <split-screen-contrast v-if="!isTemplate && !shared"></split-screen-contrast>
    <!-- 导入kml -->
    <import-kml @updateLayer="updateLayerList"></import-kml>
    <!-- 空间查询工具 -->
    <SpaceSearchTool v-if="isShowSpaceSearchDraw"></SpaceSearchTool>
    <AddSppucLayer ref="addSppucLayer" @refresh="updateLayerList" @createBindTableLayer="onCreateBindTableLayer" @showImportMarker="onShowImportMarker"></AddSppucLayer>
    <ImportMarker v-if="isShowImportMarker" @refresh="updateLayerList" :importData="importMarkerData" @close="onCloseImportMarker"></ImportMarker>
  </div>
</template>

<script>
import LeftDrawer from '@/components/Drawer/LeftDrawer'
import RightDrawer from '@/components/Drawer/RightDrawer'
import OperatHeader from '@/components/OperatHeader/OperatHeader'
import BaseLayerSet from './components/BaseLayerSet'
import BaseSetLine from './components/BaseSetLine'
import BaseSetPoint from './components/BaseSetPoint'
import BaseSetPolygon from './components/BaseSetPolygon'
import AddLayer from './components/AddLayer'
import LayerAttribute from './components/LayerAttribute'
import MapTools from '../components/MapTools'
import TableDataSelect from './components/TableDataSelect'
import ApiDataSelect from './components/ApiDataSelect'
import MarkerDataTable from './components/MarkerDataTable'
import MarkerAttribute from './components/MarkerAttribute'
import TableMarkerBind from './components/TableMarkerBind'
import AddFolder from './components/AddFolder'
import IconSelector from './components/IconSelector'
import SearchInput from '../components/POISearch/SearchInput'
import AddPointByGis from './components/AddPointByGis'
import SplitScreenContrast from './components/SplitScreenContrast'
import ImportKml from './components/ImportKml'
import SpaceSearchDraw from './components/SpaceSearchDraw'
import SpaceSearchTool from './components/SpaceSearchTool'
import AddSppucLayer from './components/sppuc/AddSppucLayer'
import ImportMarker from './components/sppuc/ImportMarker'
import {
  delLayer,
  delFolder,
  getLayerTree,
  updateFolder,
  updateLayer,
  updatePointStyle,
  updateLineStyle,
  updatePolygonStyle
} from '@/api/marker'
import { getMapDetails, sortLayer } from '@/api/mapManagement'
import * as markerStyles from '@/utils/markerStyles'
import { mapGetters, mapActions } from 'vuex'
import { treeForeach, searchBFS } from '@/utils/tree'
import ShareUtil from '@/utils/share'
import { dataset2table, validateCameraInfo } from '@/utils/util'
import { PermissionLevel } from '@/configs/constants'
import { read, utils } from 'xlsx'
// 是否开启融合通信模块
const isSppuc = process.env.VUE_APP_SPPUC === 'true'
export default {
  name: 'CesiumMarker',
  components: {
    ImportKml,
    SplitScreenContrast,
    LeftDrawer,
    RightDrawer,
    OperatHeader,
    BaseLayerSet,
    BaseSetLine,
    BaseSetPoint,
    BaseSetPolygon,
    AddLayer,
    LayerAttribute,
    MapTools,
    TableDataSelect,
    ApiDataSelect,
    MarkerDataTable,
    MarkerAttribute,
    TableMarkerBind,
    AddFolder,
    IconSelector,
    SearchInput,
    // viewShed3DBox,
    AddPointByGis,
    SpaceSearchDraw,
    SpaceSearchTool,
    AddSppucLayer,
    ImportMarker
  },
  props: {},
  provide () {
    const propertyFn = {
      markerViewer: () => {
        return this
      }
    }
    const saveLayerCheck = this.saveLayerCheck
    return new Proxy(
      {
        saveLayerCheck,
        markerViewer: undefined
      },
      {
        get: function (target, property) {
          const fn = propertyFn[property]
          return fn ? fn(target) : target[property]
        }
      }
    )
  },
  inject: ['cesiumViewer', 'shared', 'operatLayout'],
  data () {
    return {
      // layerList: [
      //   { label: '新建图层', type: 'POINT', id: 0 },
      //   { label: '新建图层', type: 'LINE', id: 1 },
      //   { label: '新建图层', type: 'PLANE', id: 2 }
      // ],
      layerTree: {
        children: []
      },
      layerIcon: {
        POINT: 'icon-spot-a',
        LINE: 'icon-Line-a2',
        PLANE: 'icon-noodles-a',
        FOLDER: 'icon-folder-b'
      },
      layerProps: {
        label: 'name',
        id: 'clientId',
        children: 'children'
      },
      // 选中图层
      selectedLayer: undefined,
      // 图层属性是否改变
      layerChanged: false,
      layerData: {},
      isShowMarkerTable: false, // 标注列表是否打开
      // 标注列表
      markerList: {},
      // 标注是否已加载
      isLoadedMarker: {},
      // 图层是否可见
      // layerVisible: {},
      loading: false,
      layerName: {},
      markerPageNum: 1,
      markerPageSize: 10,
      // 标注索引
      markerIndex: 0,
      activeIndex: 1,
      PermissionLevel,
      isSppuc,
      isShowImportMarker: false,
      importMarkerData: undefined
    }
  },
  computed: {
    ...mapGetters([
      'selectedMarker',
      'isRightDrawVisible',
      'userId',
      'isDrawState',
      '_layerId',
      'layerVisibleStorage',
      'permissionLevel',
      'layerList',
      'poi2Marker',
      'isTemplate',
      'isShowSpaceSearchDraw',
      'editMarkerData',
      'removeMarkerId',
      'apiSourceDatas',
      'updateSppucDevice',
      'markerDatas',
      'sppucAccount'
    ]),
    layerVisible () {
      if (!this.layerVisibleStorage || !this.layerVisibleStorage[this.mapId]) {
        return {}
      }
      return this.layerVisibleStorage[this.mapId]
    },
    markerCount () {
      let count = 0
      if (!this.layerList) {
        return count
      }
      for (let i = 0; i < this.layerList.length; i++) {
        count += this.layerList[i].markCount
      }
      return count
    },
    layerListShow () {
      return !this.shared || new ShareUtil().show('layerListShow')
    }
  },
  watch: {
    isRightDrawVisible (val, oldVal) {
      setTimeout(() => {
        this.activeIndex = 1
      })
    },
    selectedMarker (val, oldVal) {
      if (val) {
        // this.$refs.markerDataTable.close()
      } else {
        if (this.selectedLayer && this.selectedLayer.type !== 'FOLDER') {
          // this.$refs.markerDataTable.open()
          this.isShowMarkerTable = true
        }
      }
    },
    isDrawState (val, oldVal) {
      if (val) {
        this._lastMarkerTableVisible = this.$refs.markerDataTable.visible
        if (this._lastMarkerTableVisible) {
          this.$refs.markerDataTable.close()
        }

        // this.$store.dispatch('showRight', false)
        // this.$store.dispatch('showLeft', false)
      } else {
        if (this._lastMarkerTableVisible) {
          this.$refs.markerDataTable.open()
        }
        // this.$store.dispatch('showLeft', true)
        // if (this.selectedLayer) {
        //   this.$store.dispatch('showRight', true)
        // }
      }
    },
    // poi转标注
    poi2Marker (val) {
      if (val && val.id) {
        this.createPoiMarker(val)
      }
    },
    // 编辑标注点
    editMarkerData (val) {
      if (val) {
        this.showMarkerAttribute(val)
      }
    },
    removeMarkerId (val) {
      if (val) {
        this.updateLayerList()
        this.$store.dispatch('removeMarker', '')
      }
    },
    layerList (val) {
      setTimeout(() => {
        if (this.selectedLayer && this.$refs.layerList) {
          this.$refs.layerList.setCurrentKey(this.selectedLayer.clientId)
        }
      }, 300)
    },
    apiSourceDatas (val) {
      this.updateApiMarkerCount()
    },
    updateSppucDevice (val) {
      this.updateSppucMarkerCount()
    }
  },
  beforeDestroy () {
    this.$store.dispatch('selectMarker', undefined)
    this.$store.dispatch('setDrawState', false)
  },
  mounted () {
    // const cesiumViewer = this.$parent.$parent.$parent.$refs.cesiumViewer
    // cesiumViewer.loadServerRes('http://shine.aifaas.cn/gis/jiaozi20211223/tileset.json')
    this.mapId = this.$route.query.mapId
    if (!this.mapId) {
      this.mapId = 0
    }

    this.$store.dispatch('getFolderTree')

    this.$store.dispatch('showRight', false)
    // this.updateLayerList()
    this.updateLayerTree()

    window.onmousedown = this.saveLayerCheck.bind(this)
    document.getElementById('cesiumViewer').onclick =
      this.saveLayerCheck.bind(this)
    // this.getMapStyle()
    // 获取地图绑定的模型
    // this.getMapModel()
    this.$nextTick(() => {
      this.$store.dispatch('showLeft', true)
      this.$store.dispatch('showRight', false)
    })
  },
  methods: {
    ...mapActions(['setLayerId']),

    isInRightDrawer (event) {
      const clientWidth = document.body.clientWidth
      const clientHeight = document.body.clientHeight
      const left = clientWidth - 260
      const top = 47
      if (
        this.isRightDrawVisible &&
        event.x < clientWidth &&
        event.x > left &&
        event.y > top &&
        event.y < clientHeight
      ) {
        return true
      }
    },
    saveLayerCheck (event) {
      if (
        this.layerChanged &&
        !this.isShowMessageBox &&
        !this.$refs.iconSelector.isShow
      ) {
        this.$Submit({
          message: '您修改了图层属性，是否保存？',
          confirmButtonText: '保存',
          cancelButtonText: '还原',
          confirm: () => {
            // this.layerChanged = false
            this.isShowMessageBox = false
            this.updateLayerStyle()
          },
          cancel: () => {
            this.isShowMessageBox = false
            // self.layerChanged = false
            this.resetLayerStyle()
          }
        })
        this.isShowMessageBox = true
      }
    },
    // 创建poi标注
    createPoiMarker (data) {
      const marker = this.$cesiumPlus.markerManager.getMarkerById(
        `poisearch-${data.id}`
      )
      if (!marker) {
        return
      }
      let selectedLayerId
      if (this.selectedLayer && this.selectedLayer.type === 'POINT' && this.selectedLayer.dataSourceType !== 'API') {
        selectedLayerId = this.selectedLayer.id
      }
      this.$refs.markerAttribute.show({
        entityId: marker.id,
        type: 'POINT',
        markerName: data.name,
        selectedLayerId: selectedLayerId
      })
    },
    onDrawBegin () {
      this.operatLayout.showMarkerDetail(false)
      this.$refs.markerAttribute.close()
    },
    showBindMarker (layerId) {
      this.$refs.tableMarkerBind.show(layerId)
    },
    reloadBindMarker (layerId) {
      if (!this.$refs.tableMarkerBind.isShow) {
        return
      }
      this.$refs.tableMarkerBind.reload(layerId)
    },
    closeBindMarker () {
      this.$refs.tableMarkerBind.onClose()
    },
    onSelectBindMarker (item) {
      this.$refs.markerAttribute.bindMarker(item)
    },
    onShowIconSelector (iconId) {
      this.$refs.iconSelector.open(iconId)
    },
    onSetMarkerIcon (id) {
      this.$refs.baseSetPoint.setIcon(id)
    },
    folderForeach (data, func) {
      if (data.layers || data.children) {
        func(data)
      }
      if (data.children) {
        for (let i = 0; i < data.children.length; i++) {
          this.folderForeach(data.children[i], func)
        }
      }
    },
    getLayerIcon (data) {
      // if (data.dataSourceType === 'API') {
      //   return 'icon-API'
      // }
      return this.layerIcon[data.type]
    },
    // 拖动
    allowDrop (draggingNode, dropNode, type) {
      if (dropNode.data.type !== 'FOLDER' && type === 'inner') {
        return false
      }
      return true
    },
    handleDragEnd (draggingNode, dropNode, dropType, ev) {
      // let draggingId = draggingNode.data.id
      let parentId = dropNode.data.groupId
        ? dropNode.data.groupId
        : dropNode.data.parentId
      if (dropType === 'inner') {
        // draggingId = draggingNode.data.id
        parentId = dropNode.data.id
      } else {
        parentId = dropNode.data.groupId
          ? dropNode.data.groupId
          : dropNode.data.parentId
      }
      if (draggingNode.data.type === 'FOLDER') {
        const data = JSON.parse(JSON.stringify(draggingNode.data))
        data.parentId = parentId
        updateFolder(data).then((res) => {
          this.updateLayerSorts()
        })
      } else {
        const data = JSON.parse(JSON.stringify(draggingNode.data))
        data.groupId = parentId
        updateLayer(data).then((res) => {
          this.updateLayerSorts()
        })
      }
    },
    // 更新api标注数量
    updateApiMarkerCount () {
      treeForeach(this.layerTree.children, 'children', (layerItem) => {
        if (layerItem.dataSourceType === 'API') {
          const config = JSON.parse(layerItem.config)
          if (this.apiSourceDatas[config.dataSourceId]) {
            const datas = dataset2table(this.apiSourceDatas[config.dataSourceId])
            layerItem.markCount = datas.length
            this.layerList.find((item) => { return item.id === layerItem.id }).markCount = datas.length
          }
        }
      })
    },
    // 更新融合通信图层数量
    updateSppucMarkerCount () {
      treeForeach(this.layerTree.children, 'children', (layerItem) => {
        if (layerItem.extendConfig && layerItem.extendConfig.isSppucData) {
          const datas = this.cesiumViewer.sppucManager.getDevicesOl(layerItem.extendConfig.deviceType)
          layerItem.markCount = datas.length
        }
      })
    },
    // 更新图层排序
    async updateLayerSorts () {
      const sorts = []
      treeForeach(this.layerTree.children, 'children', (item) => {
        sorts.push(item.clientId)
      })
      await sortLayer({
        id: this.mapId,
        sortRules: sorts
      })
      this.updateLayerList(false)
      this.$store.dispatch('getLayerTree')
      this.$store.dispatch('showRight', false)
    },
    // 更新图层树
    async updateLayerTree () {
      // 更新排序
      let sortRules = []
      const res2 = await getMapDetails({
        id: this.mapId
      })
      if (res2.code === 200) {
        sortRules = res2.data.sortRules ? res2.data.sortRules : []
      }
      const layerSort = sortRules.filter(item => { return item.startsWith('layer-') }).map(item => { return item.replace('layer-', '') })
      this.$cesiumPlus.markerManager.sortDataSource(layerSort)
      const res = await getLayerTree({
        mapId: this.mapId
      })
      if (res.code === 200) {
        this.layerName = {}
        this.layerTree = JSON.parse(JSON.stringify(res.data))
        // this.layerTree = {}
        this.folderForeach(this.layerTree, (item) => {
          if (item.children && item.children.length > 0) {
            for (let i = 0; i < item.children.length; i++) {
              if (item.children[i].type) {
                continue
              }
              const clientId = 'folder-' + item.children[i].id
              item.children[i].clientId = clientId
              item.children[i].type = 'FOLDER'
              item.children[i].markCount = 0
              item.children[i].sort = sortRules.indexOf(clientId)
            }
          }
          if (item.layers && item.layers.length > 0) {
            if (!item.children) {
              item.children = []
            }
            for (let i = 0; i < item.layers.length; i++) {
              const clientId = 'layer-' + item.layers[i].id
              const layerItem = JSON.parse(JSON.stringify(item.layers[i]))
              layerItem.clientId = clientId
              layerItem.parentId = item.layers[i].groupId
              layerItem.sort = sortRules.indexOf(clientId)
              item.children.push(layerItem)
            }
          }
          item.children.sort((a, b) => {
            return a.sort - b.sort
          })
        })
        // 更新文件夹标注数量
        treeForeach(this.layerTree.children, 'children', (item) => {
          if (item.type === 'FOLDER') {
            let markCount = 0
            if (item.children) {
              treeForeach(item.children, 'children', (childItem) => {
                if (childItem.type !== 'FOLDER') {
                  markCount += childItem.markCount
                }
              })
            }
            item.markCount = markCount
          }
        })
        if (this.selectedLayer) {
          treeForeach(this.layerTree.children, 'children', (item) => {
            if (item.type !== 'FOLDER' && item.id === this.selectedLayer.id) {
              this.clickLayer(item)
            }
          })
        }
        this.updateApiMarkerCount()
        this.updateSppucMarkerCount()
      }
    },
    // 更新图层列表
    updateLayerList (isRefreshMarker = true) {
      console.log('updateLayerList, isRefreshMarker=', isRefreshMarker)
      if (this._layerId) {
        this.isShowMarkerTable = true
        this.layerList.forEach((item) => {
          if (item.id === this._layerId) {
            this.layerData = item
          }
        })
      }
      this.$refs.markerDataTable.refreshTableData() // 更新标注列表数据

      this.updateLayerTree()
      this.$store.dispatch('getLayerList', { refreshMarker: isRefreshMarker })
      this.$store.dispatch('getFolderTree')
    },
    // 获取图层样式
    getLayerStyle (layerId) {
      for (let i = 0; i < this.layerList.length; i++) {
        if (this.layerList[i].id === layerId) {
          let style
          if (this.layerList[i].type === 'POINT') {
            style = markerStyles.adapterPointStyle(this.layerList[i].pointStyle)
          } else if (this.layerList[i].type === 'LINE') {
            style = markerStyles.adapterLineStyle(this.layerList[i].lineStyle)
          } else if (this.layerList[i].type === 'PLANE') {
            style = markerStyles.adapterPolygonStyle(
              this.layerList[i].planeStyle
            )
          }
          return style
        }
      }
    },
    // 显示/隐藏图层
    showMarker (data) {
      let type = data.type
      if (type !== 'FOLDER') {
        type = 'LAYER'
      }
      // const layerId = data.id
      const visible = this.layerVisible[data.clientId] !== false
      // 保存
      const layerVisible = JSON.parse(JSON.stringify(this.layerVisible))
      layerVisible[data.clientId] = !visible
      const layerVisibleStorage = JSON.parse(
        JSON.stringify(this.layerVisibleStorage)
      )
      layerVisibleStorage[this.mapId] = layerVisible
      // this.$set(this.layerVisible, data.clientId, !visible)
      // this.layerVisibleStorage[this.mapId] = this.layerVisible
      this.$store.commit('SET_LAYER_VISIBLE', layerVisibleStorage)
      if (!this.isTemplate) {
        localStorage.setItem(
          'layerVisible' + this.userId,
          JSON.stringify(layerVisibleStorage)
        )
      }
      // 更新图层显/隐
      this.cesiumViewer.updateLayerVisible()
    },
    getLayerVisible (item) {
      let visible = this.layerVisible[item.clientId] !== false
      if (item.parentId) {
        const parentItems = searchBFS(
          this.layerTree.children,
          'children',
          (childItem) => {
            return childItem.type === 'FOLDER' && childItem.id === item.parentId
          }
        )
        if (parentItems && parentItems[0]) {
          visible = visible && this.getLayerVisible(parentItems[0])
        }
      }
      return visible
    },
    // 创建文件夹
    createFolder () {
      this.$refs.addFolder.open()
    },
    createLayer () {
      this.$refs.addLayer.open()
    },
    // 关闭添加图层
    closeAddLayer () {
      this.$refs.addLayer.onClose()
    },
    // 删除文件夹
    onRemoveFolder (data) {
      this.$Delete({
        message: '您确定删除该数据吗，删除后不可恢复？',
        confirm: () => {
          this.removeFolder([data.id])
        },
        cancel: () => {}
      })
    },
    removeFolder (ids) {
      delFolder({
        ids: ids
      }).then((res) => {
        if (res.code === 200) {
          this.$Message('success', '操作成功!')
          // 删除图层后，默认显示第一个图层的标注列表数据
          // const arr = this.layerList.filter((item, index) => {
          //   return item.id !== ids[0]
          // })
          // this.layerData = arr[0] || {}
          // this.$store.dispatch('setLayerId', null)

          setTimeout(() => {
            this.updateLayerList()
          }, 1000)
          // 删除文件夹下的标注
          for (let i = 0; i < ids.length; i++) {
            treeForeach(this.layerTree.children, 'children', (item) => {
              if (item.type === 'FOLDER' && item.id === ids[i]) {
                treeForeach(item.children, 'children', (childItem) => {
                  if (childItem.type !== 'FOLDER') {
                    this.removeMarkerLayer(childItem.id)
                  }
                })
              }
            })
          }
        }
      })
    },
    // 显示标注列表
    async showMarkerList (data) {
      this.layerData = data
      await this.$nextTick()
      this.$refs.markerDataTable.open()
      // if (this.layerData.dataSourceType === 'API') {
      //   this.$refs.apiDataTable.open()
      // } else {
      //   this.$refs.makerTable.open()
      // }

      this.isShowMarkerTable = true
    },
    // 更新标注列表显示状态
    updateMarkerTable () {
      this.isShowMarkerTable = false
    },
    // 显示图层属性
    showLayerAttribute (id) {
      this.$refs.layerAttribute.open(id)
    },
    // 删除图层
    removeLayer (ids) {
      delLayer({
        ids: ids
      }).then((res) => {
        if (res.code === 200) {
          this.$Message('success', '删除成功!')
          this.$store.dispatch('showRight', false)
          // 删除图层后，默认显示第一个图层的标注列表数据
          const arr = this.layerList.filter((item, index) => {
            return item.id !== ids[0]
          })
          this.layerData = arr[0] || {}
          if (arr.length <= 0) {
            this.$refs.markerDataTable.close()
          }
          this.$store.dispatch('setLayerId', null)
          setTimeout(() => {
            this.updateLayerList()
          }, 1000)
          for (let i = 0; i < ids.length; i++) {
            this.removeMarkerLayer(ids[i])
          }
        }
      })
    },
    // 删除图层
    removeMarkerLayer (layerId) {
      const layer = this.layerList.find(item => { return item.id === layerId })
      if (layer.dataSourceType === 'API') {
        this.$cesiumPlus.primitiveManager.remvoeBundle(layerId)
        const config = JSON.parse(layer.config)
        this.$store.commit('destroyDataset', config.dataSourceId)
      } else {
        this.$cesiumPlus.markerManager.removeMarkerByLayer(layerId, true)
      }
      if (this.selectedLayer.id === layerId) {
        this.selectedLayer = undefined
      }
    },
    // 删除图层
    onRemoveLayer (id) {
      this.$Delete({
        message: '您确定删除该数据吗，删除后不可恢复？',
        confirm: () => {
          this.removeLayer([id])
        },
        cancel: () => {}
      })
    },
    onLayerStyleChange (data) {
      // this.selectedLayer.name = data.name
      this.layerChanged = true
    },
    async clickLayer (data, node, component) {
      // 点击图层列表，如果标注列表已显示，则切换数据
      // await this.$store.dispatch('setLayerId', data.id)
      await this.setLayerId(data.id)
      if (this.isShowMarkerTable && data.type !== 'FOLDER') {
        this.showMarkerList(data)
      }
      // const treeChildren = this.$refs.layerList.$el.children
      // for (let i = 0; i < treeChildren.length; i++) {
      //   if (treeChildren[i] === component.$el) {
      //     treeChildren[i].setAttribute('style', 'background-color: #334966;border-radius: 0.07rem;')
      //   } else {
      //     treeChildren[i].setAttribute('style', 'background-color: unset;border-radius: unset;')
      //   }
      // }

      const selData = JSON.parse(JSON.stringify(data))
      this.selectedLayer = selData
      this.$refs.baseLayerSet.setData(selData)
      if (selData.type === 'POINT') {
        this.$refs.baseSetPoint.setData(selData.pointStyle, selData)
      } else if (selData.type === 'LINE') {
        this.$refs.baseSetLine.setData(selData.lineStyle, selData)
      } else if (selData.type === 'PLANE') {
        this.$refs.baseSetPolygon.setData(selData.planeStyle, selData)
      }
      if (this.isTemplate) {
        return
      }
      this.$store.dispatch('showRight', true)
      await this.$nextTick()
      this.$refs.layerList.setCurrentKey(data.clientId)
    },
    async onDrawEnd ({ type, entity, positions }) {
      let marker
      if (type === CesiumPlus.DrawMode.Curve) {
        marker = await this.$cesiumPlus.markerManager.createMarker({
          entity: entity,
          layerId: '_temp',
          drawMode: type
        })
      } else {
        marker = await this.$cesiumPlus.markerManager.createMarker({
          entity: entity,
          layerId: '_temp',
          drawMode: type
        })
      }
      let markType
      if (
        type === CesiumPlus.DrawMode.Point ||
        type === CesiumPlus.DrawMode.Marker
      ) {
        markType = 'POINT'
      } else if (
        type === CesiumPlus.DrawMode.Polyline ||
        type === CesiumPlus.DrawMode.Curve
      ) {
        markType = 'LINE'
      } else if (
        type === CesiumPlus.DrawMode.Polygon ||
        type === CesiumPlus.DrawMode.Circle
      ) {
        markType = 'PLANE'
      }
      let selectedLayerId
      if (this.selectedLayer && markType === this.selectedLayer.type && this.selectedLayer.dataSourceType !== 'API') {
        selectedLayerId = this.selectedLayer.id
      }
      this.$refs.markerAttribute.show({
        entityId: marker.id,
        type: markType,
        selectedLayerId: selectedLayerId
      })
    },
    // 显示编辑标注
    showMarkerAttribute ({ id, activeTab }) {
      // this.$store.dispatch('showRight', false)
      // this.$store.dispatch('showLeft', false)
      this.operatLayout.showMarkerDetail(false)
      this.$refs.markerAttribute.edit(id, activeTab)
      const marker = this.$cesiumPlus.markerManager.getMarkerById(id)
      if (marker) {
        marker.hover = true
        marker.showLabel(true)
        const layer = this.layerList.find((item) => { return item.id === marker.layerId })
        // 是否飞向标注点
        const isFlyTo = !(layer && layer.action && layer.action.flyTo === false)
        if (isFlyTo) {
          const cameraInfo = JSON.parse(marker.getProperties('camera_info') || '{}')
          if (cameraInfo && validateCameraInfo(cameraInfo)) {
            this.$cesiumPlus.cameraManager.flyTo({
              position: [cameraInfo.cameraLon, cameraInfo.cameraLat, cameraInfo.cameraHeight],
              direction: [cameraInfo.cameraHeading, cameraInfo.cameraPitch, cameraInfo.cameraRoll]
            })
          } else {
            const geoJson = JSON.parse(marker.toGeoJson())
            this.$cesiumPlus.cameraManager.zoomToGeometry(geoJson)
          }
        }
      }
      // this.onSelectMapMarker(id)
    },
    onCloseMarkerAttribute () {
      this.$refs.tableMarkerBind.close()
      if (this.selectedLayer && this.selectedLayer.type !== 'FOLDER') {
        this.$refs.markerDataTable.open()
        this.isShowMarkerTable = true
      }
    },
    // 选中标注效果
    onSelectMapMarker (id) {
      this.$store.dispatch('selectMarker', id)
    },
    // 显示标注详情
    showMarkerDetails (data) {
      this.operatLayout.showMarkerDetail(true, data)
      this.onSelectMapMarker(data)
    },
    // 显示api标注详情
    showApiMarkerDetails (data) {
      this.operatLayout.onSelectPrimitive(data)
    },
    // 保存更新图层属性
    updateLayerStyle () {
      this.loading = true
      if (!this.selectedLayer.parentId) {
        this.selectedLayer.parentId = 0
      }
      this.selectedLayer.groupId = this.selectedLayer.parentId
      if (this.selectedLayer.type === 'FOLDER') {
        updateFolder(this.selectedLayer)
          .then((res) => {
            this.loading = false
            if (res.code === 200) {
              this.layerChanged = false
              this.$Message('success', res.msg)
              this.updateLayerList()
            }
          })
          .catch((res) => {
            this.loading = false
          })
      } else {
        updateLayer(this.selectedLayer).then((res) => {
          if (res.code === 200) {
            this.$Message('success', res.msg)
          }
        })
      }

      if (this.selectedLayer.type === 'POINT') {
        updatePointStyle(this.selectedLayer.pointStyle)
          .then((res) => {
            if (res.code === 200) {
              // this.$Message('success', res.msg)
              this.layerChanged = false
              this.loading = false
              this.updateLayerList()
            }
          })
          .catch((res) => {
            this.loading = false
          })
      } else if (this.selectedLayer.type === 'LINE') {
        updateLineStyle(this.selectedLayer.lineStyle)
          .then((res) => {
            if (res.code === 200) {
              // this.$Message('success', res.msg)
              this.layerChanged = false
              this.loading = false
              this.updateLayerList()
            }
          })
          .catch((res) => {
            this.loading = false
          })
      } else if (this.selectedLayer.type === 'PLANE') {
        updatePolygonStyle(this.selectedLayer.planeStyle)
          .then((res) => {
            if (res.code === 200) {
              // this.$Message('success', res.msg)
              this.layerChanged = false
              this.loading = false
              this.updateLayerList()
            }
          })
          .catch((res) => {
            this.loading = false
          })
      }
      this.$refs.baseLayerSet.setOrigin(this.selectedLayer)
    },
    // 还原图层属性
    resetLayerStyle () {
      this.$refs.baseLayerSet.resetData()
      this.$nextTick(() => {
        this.layerChanged = false
      })
    },
    // 绑定数据
    onBindTable (data) {
      if (data.dataSourceType === 'API') {
        this.$refs.apiDataSelect.show(data)
      } else {
        this.$refs.tableDataSelect.show(data)
      }
    },
    // 创建绑定数据表单图层
    onCreateBindTableLayer (data) {
      if (data.dataSourceType === 'API') {
        this.$refs.apiDataSelect.show(data)
      } else {
        this.$refs.tableDataSelect.show(data)
      }
    },
    // 获取地图绑定的模型
    // getMapModel () {
    //   if (this.$route.query.areaId) {
    //     const cesiumViewer = this.$parent.$parent.$parent.$refs.cesiumViewer
    //     getMapModel({ id: this.$route.query.areaId }).then((res) => {
    //       if (res.code === 200) {
    //         if (res.data.model) {
    //           cesiumViewer.loadServerRes(res.data.model.link, {
    //             height: res.data.model.height ? res.data.model.height : 0
    //           })
    //         }
    //         if (res.data.children && res.data.children.length) {
    //           treeForeach(res.data.children, 'children', (item) => {
    //             if (item && item.model) {
    //               cesiumViewer.loadServerRes(item.model.link, {
    //                 height: item.model.height ? item.model.height : 0
    //               })
    //             }
    //           })
    //         }
    //       }
    //     })
    //   }
    // },
    // 创建标注成功
    onCreatedMarker () {
      treeForeach(this.layerTree.children, 'children', (item) => {
        if (item.type !== 'FOLDER' && item.id === this._layerId) {
          this.clickLayer(item)
        }
      })

      this.$refs.markerDataTable.open()
      // 关闭poi详情弹窗
      this.$parent.$parent.$parent.$refs.poiDetail.close()
    },
    onPreviewPic (data) {
      this.$parent.$parent.$parent.onPreviewPic(data)
    },
    onInputPoint () {
      this.$refs.addPointByGis.show()
    },
    createSppucLayer () {
      this.$refs.addSppucLayer.open()
    },
    // 读取Excel文件
    readExcel (file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onload = ev => {
          try {
            const data = ev.target.result
            const workbook = read(data, { type: 'binary' })
            const params = []
            // 取对应表生成json表格内容
            workbook.SheetNames.forEach(item => {
              const dataList = utils.sheet_to_json(workbook.Sheets[item])
              const dataHeader = []
              for (const key in dataList[0]) {
                dataHeader.push({
                  name: key,
                  id: key
                })
              }
              for (let i = 0; i < dataList.length; i++) {
                dataList[i].uniqueId = i + 1
              }
              params.push({
                name: item,
                dataList: dataList,
                dataHeader: dataHeader
              })
            })
            resolve(params)
          } catch (e) {
            reject(e)
          }
        }
        fileReader.readAsBinaryString(file)
      })
    },
    // 显示导入标注界面
    async onShowImportMarker (data) {
      this.isShowImportMarker = true
      const excelData = await this.readExcel(data.file)
      if (excelData.length <= 0) {
        this.$Message('error', '解析Excel文件失败')
        return
      }
      this.importMarkerData = {
        layerId: data.layerId,
        tablesData: excelData[0]
      }
    },
    // 关闭导入标注界面
    onCloseImportMarker () {
      this.importMarkerData = undefined
      this.isShowImportMarker = false
    },
    // 点击sppuc标注
    onClickSppucMarker (data) {
      this.cesiumViewer.onClickSppucDevice(data)
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.marker-viewer.f944f5202 {
  .header {
    // text-align: left;
    line-height: 40px;
    .title {
      float: left;
      margin-left: 10px;
    }
    .save-btn {
      height: 24px;
      font-size: 12px !important;
      padding: 0 5px !important;
      float: right;
      margin-right: 10px;
      margin-top: 7px;
    }
    .icons {
      float: right;
      margin-right: 10px;
      padding-top: 4px;
    }
  }
  .body {
    font-size: $font-size12;
    .body-tree {
      display: flex;
      flex-direction: column;
      .statistics {
        color: $font-color9;
        margin-left: 12px;
        margin-top: 14px;
        // margin-bottom: 10px;
        display: block;
        text-align: left;
      }
      .layer-list {
        flex: 1;
        padding: 8px;
        padding-top: 10px;
        width: 100%;
        overflow-y: overlay;
        .layer-item {
          // height: 32px;
          // background: rgba($font-colorf, 0.1);
          // border-radius: 6px;
          width: 220px;
          overflow: hidden;
          height: 32px;
          text-align: left;
          display: flex;
          justify-content: space-between;
          .title {
            display: inline-block;
            width: 250px;
            text-align: left;
            vertical-align: bottom;
            height: 32px;
            line-height: 32px;
            @include show_ellipsis(1);
          }
          .count {
            margin-left: 8px;
            color: #999;
          }
          .action-icon {
            float: right;
          }
          .custom-icon {
            transform: scale(0.8);
            opacity: 0.3;
            margin-left: -5px;
            &.more-icon{
              transform: translateY(-6px) scale(0.8);
            }
          }
          .layerIconStyle {
            &:hover {
              background-color: unset !important;
            }
          }
        }
      }
    }

    .el-icon-more{
      transform: rotate(90deg);
      font-size: 14px;
    }
  }
  .custom-icon {
    transition: all 0s !important;
  }
  .el-tree {
    background: unset !important;
    .el-tree-node {
      // height: 32px;
      &:hover {
        // background-color: rgba(255, 255, 255, 0.1) !important;
        border-radius: 7px !important;
      }
      // &:focus {
      //   background-color: $table-hover-color !important;
      //   border-radius: 7px !important;
      // }
      &.is-current {
        .layer-item {
          .custom-icon {
            opacity: 1;
          }
        }
      }
    }
    .el-tree-node__content {
      height: 32px;
      &:hover {
        background-color: rgba(255, 255, 255, 0.1) !important;
        border-radius: 7px;
        .more-icon,
        .icon-ashbin {
          visibility: visible !important;
          width: 32px !important;
        }
        .layer-item {
          .custom-icon {
            opacity: 1;
          }
        }
      }
    }
    .el-tree-node:focus > .el-tree-node__content {
      background-color: rgba(255, 255, 255, 0.1) !important;
    }
  }
  .el-tree--highlight-current .el-tree-node.is-current {
    background-color: #273040;
    border-radius: 7px;
    > .el-tree-node__content {
      background-color: #334966 !important;
      border-radius: 7px;
    }
  }
  .right-drawer {
    .marker-right{
      display: flex;
      flex-direction: column;
      height: 100%;
      .right-body{
        height: 100%;
        overflow-y: overlay;
      }
    }
    .header {
      .custom-icon {
        float: right;
        margin-right: 10px;
        margin-top: 3px;
      }
    }
    .spaceSearch {
      .header {
        .title {
          margin-right: 20px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          cursor: pointer;
          &.active {
            color: #ffffff;
          }
        }
      }
      .body {
        padding: 15px 12px;
        box-sizing: border-box;
        .total {
          text-align: left;
          margin-bottom: 18px;
          .line {
            width: 3px;
            height: 10px;
            background: #00a4f0;
            border-radius: 2px;
            display: inline-block;
            margin-right: 5px;
          }
          .name {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.shared {
  --no-left: 10px;
}
</style>
